const awsConfig = {
	aws_user_pools_id: process.env.CLIENT_USER_POOL_ID,
	aws_user_pools_web_client_id: process.env.CLIENT_WEB_CLIENT_ID,
};

export default awsConfig;
